import React from 'react';
import ReactDOM from 'react-dom';
import localCookie from '@liepin/native-sweet-fe';
import { userUtil } from '@liepin/js-core4c-fe';
import LoginProvider from '../store/provider/LoginProvider';
import Content from './components/Content';
import { ILoginProps, IRenderLoginProps } from '../types';
import { FE_WWW_GUIDE_NEW } from '../common/js/constants';
import './index.less';

export function LoginLayerComponent({ ...props }: ILoginProps) {
    return (
        <LoginProvider {...props}>
            <Content />
        </LoginProvider>
    )
}

export function renderRegisterlayer({ ...props }: IRenderLoginProps) {
    if (userUtil.isLPUser || localCookie.get(FE_WWW_GUIDE_NEW) || userUtil.isLogin) {
        return;
    }

    const divContainer = document.createElement('div');
    const renderBody = document.querySelector('body')
    if (renderBody) {
        renderBody.appendChild(divContainer);
        ReactDOM.render(
            <LoginLayerComponent {...props} />,
            divContainer,
        );
    }
}

